import { DocumentTextIcon, MusicalNoteIcon, VideoCameraIcon } from '@heroicons/react/24/outline'
import type { Attachment } from '../../client'

export default function AttachmentPreview({ attachment }: { attachment: Attachment }) {
  if (attachment.kind === 'image') {
    return (
      <img
        src={attachment.url}
        alt={attachment.original_filename ?? ''}
        className="size-full object-cover"
      />
    )
  }

  if (attachment.kind === 'video') {
    return (
      <span className="relative block size-full bg-slate-900">
        <video src={attachment.url} preload="metadata" muted playsInline className="size-full object-cover" />
        <span className="absolute right-0.5 bottom-0.5 rounded-full bg-black/70 p-0.5">
          <VideoCameraIcon className="size-3 text-white" />
        </span>
      </span>
    )
  }

  if (attachment.kind === 'audio') {
    return (
      <span className="flex size-full items-center justify-center bg-slate-900">
        <MusicalNoteIcon className="size-5 text-white" />
      </span>
    )
  }

  const name = attachment.original_filename ?? new URL(attachment.url).pathname
  return (
    <span className="flex size-full flex-col items-center justify-center gap-0.5 bg-stone-200 text-stone-600">
      <DocumentTextIcon className="size-5" />
      <span className="max-w-full truncate px-1 text-[9px] font-semibold uppercase">
        {name.includes('.') ? name.split('.').pop() : 'file'}
      </span>
    </span>
  )
}
